import React from "react";
import { useNavigate } from "react-router-dom";


import heroImg from "../../assets/page-banner-img.jpg";
import step1Img from "../../assets/Picture1.png";
import step2Img from "../../assets/Picture2.png";
import step3Img from "../../assets/Picture3.png";
import step4Img from "../../assets/Picture4.png";
import step5Img from "../../assets/Picture5.png";

const styles = `
  /* ── Reset ── */
  * { box-sizing: border-box; }

  /* ── Hero ── */
  .gstr-hero-img {
    width: 100%;
    height: 420px;
    object-fit: cover;
    display: block;
  }

  .gstr-hero-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 90px;
    background: rgba(36,199,184,0.72);
    display: flex;
    align-items: center;
    padding-left: 70px;
    box-sizing: border-box;
  }

  .gstr-hero-title {
    color: #fff;
    font-size: 34px;
    font-weight: 700;
    font-family: "Exo", sans-serif;
    margin: 0;
  }

  /* ── Main content box ── */
  .gstr-content-box {
    width: 85%;
    max-width: 1700px;
    margin: 35px auto;
    background: #f3f3f3;
    padding: 32px;
  }

  /* ── Step images ── */
  .gstr-step-img {
    width: 92%;
    display: block;
    margin: 40px auto 55px;
    height: auto;
  }

  /* ── Flow Steps ── */
  .gstr-flow-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 65px;
  }

  .gstr-step-box {
    background: #4d8fbe;
    color: #fff;
    width: 160px;
    min-height: 105px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 14px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    box-shadow: 0 4px 10px rgba(0,0,0,0.12);
  }

  .gstr-step-label {
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 10px;
  }

  .gstr-arrow {
    font-size: 28px;
    color: #666;
    font-weight: 300;
  }

  /* ── Section headings ── */
  .gstr-h2 {
    font-size: 32px;
    text-align: center;
    margin-bottom: 28px;
    font-weight: 800;
    font-family: "Exo", sans-serif;
  }

  .gstr-purpose-h2 {
    font-size: 30px;
    text-align: center;
    margin-bottom: 25px;
    font-weight: 800;
    font-family: "Exo", sans-serif;
    color: #111;
  }

  .gstr-h3 {
    font-size: 22px;
    margin-top: 35px;
    margin-bottom: 18px;
    font-weight: 700;
  }

  .gstr-h3-sm {
    font-size: 18px;
    margin-top: 35px;
    margin-bottom: 18px;
    font-weight: 700;
  }

  /* ── Next post box ── */
  .gstr-next-box {
    border: 2px solid #fff;
    padding: 28px;
    background: #24c7b8;
  }

  .gstr-next-title {
    font-size: 20px;
    line-height: 1.5;
    color: #10213a;
    font-weight: 700;
    margin-bottom: 16px;
    font-family: "Exo", sans-serif;
  }

  /* ── Comparison box ── */
  .gstr-compare-box {
    background: #fff;
    padding: 18px;
    margin-top: 20px;
    margin-bottom: 28px;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
  }

  /* ── Large Desktop: 1400px+ ── */
  @media (min-width: 1400px) {
    .gstr-content-box {
      padding: 44px;
    }
    .gstr-hero-img {
      height: 500px;
    }
    .gstr-hero-title {
      font-size: 40px;
    }
    .gstr-hero-overlay {
      height: 100px;
      padding-left: 90px;
    }
    .gstr-h2 {
      font-size: 36px;
    }
    .gstr-purpose-h2 {
      font-size: 34px;
    }
    .gstr-h3 {
      font-size: 24px;
    }
    .gstr-step-box {
      width: 190px;
      font-size: 15px;
    }
  }

  /* ── Ultra-wide: 1920px+ ── */
  @media (min-width: 1920px) {
    .gstr-content-box {
      padding: 56px;
    }
    .gstr-hero-img {
      height: 560px;
    }
    .gstr-hero-title {
      font-size: 46px;
    }
    .gstr-hero-overlay {
      height: 110px;
      padding-left: 110px;
    }
    .gstr-h2 {
      font-size: 40px;
    }
    .gstr-purpose-h2 {
      font-size: 38px;
    }
  }

  /* ── Tablet Portrait: 768px – 1023px ── */
  @media (max-width: 1023px) and (min-width: 768px) {
    .gstr-hero-img {
      height: 320px;
    }
    .gstr-hero-title {
      font-size: 28px;
    }
    .gstr-hero-overlay {
      height: 76px;
      padding-left: 40px;
    }
    .gstr-content-box {
      width: 92%;
      padding: 28px 24px;
    }
    .gstr-h2 {
      font-size: 27px;
    }
    .gstr-purpose-h2 {
      font-size: 26px;
    }
    .gstr-h3 {
      font-size: 20px;
    }
    .gstr-flow-wrap {
      gap: 8px;
    }
    .gstr-step-box {
      width: 140px;
      font-size: 13px;
      padding: 12px 10px;
    }
    .gstr-arrow {
      font-size: 22px;
    }
    .gstr-compare-box {
      font-size: 18px;
    }
    .gstr-next-title {
      font-size: 18px;
    }
  }

  /* ── Large Mobile: 481px – 767px ── */
  @media (max-width: 767px) and (min-width: 481px) {
    .gstr-hero-img {
      height: 240px;
    }
    .gstr-hero-title {
      font-size: 22px;
    }
    .gstr-hero-overlay {
      height: 64px;
      padding-left: 24px;
    }
    .gstr-content-box {
      width: 95%;
      padding: 22px 18px;
      margin: 22px auto;
    }
    .gstr-h2 {
      font-size: 23px;
      margin-bottom: 20px;
    }
    .gstr-purpose-h2 {
      font-size: 22px;
      margin-bottom: 18px;
    }
    .gstr-h3 {
      font-size: 18px;
      margin-top: 26px;
      margin-bottom: 14px;
    }
    .gstr-h3-sm {
      font-size: 16px;
      margin-top: 26px;
    }
    .gstr-flow-wrap {
      gap: 8px;
      margin-bottom: 40px;
    }
    .gstr-step-box {
      width: 130px;
      min-height: 90px;
      font-size: 12px;
      padding: 10px 8px;
      border-radius: 12px;
    }
    .gstr-step-label {
      font-size: 13px;
      margin-bottom: 7px;
    }
    .gstr-arrow {
      font-size: 18px;
    }
    .gstr-step-img {
      width: 100%;
      margin: 28px auto 40px;
    }
    .gstr-compare-box {
      font-size: 17px;
      padding: 14px;
    }
    .gstr-next-box {
      padding: 20px;
    }
    .gstr-next-title {
      font-size: 17px;
    }
  }

  /* ── Small Mobile: up to 480px ── */
  @media (max-width: 480px) {
    .gstr-hero-img {
      height: 190px;
    }
    .gstr-hero-title {
      font-size: 18px;
    }
    .gstr-hero-overlay {
      height: 56px;
      padding-left: 16px;
    }
    .gstr-content-box {
      width: 100%;
      padding: 18px 14px;
      margin: 16px auto;
    }
    .gstr-h2 {
      font-size: 20px;
      margin-bottom: 16px;
    }
    .gstr-purpose-h2 {
      font-size: 19px;
      margin-bottom: 14px;
    }
    .gstr-h3 {
      font-size: 17px;
      margin-top: 22px;
      margin-bottom: 12px;
    }
    .gstr-h3-sm {
      font-size: 15px;
      margin-top: 22px;
      margin-bottom: 12px;
    }
    .gstr-flow-wrap {
      gap: 8px;
      margin-bottom: 32px;
      justify-content: center;
    }
    .gstr-arrow {
      display: none;
    }
    .gstr-step-box {
      width: 120px;
      min-height: 88px;
      font-size: 12px;
      padding: 10px 8px;
      border-radius: 10px;
    }
    .gstr-step-label {
      font-size: 12px;
      margin-bottom: 6px;
    }
    .gstr-step-img {
      width: 100%;
      margin: 22px auto 32px;
    }
    .gstr-compare-box {
      font-size: 15px;
      padding: 12px;
    }
    .gstr-next-box {
      padding: 16px;
    }
    .gstr-next-title {
      font-size: 15px;
    }
  }

  /* ── Extra Small: up to 400px ── */
  @media (max-width: 400px) {
    .gstr-hero-img {
      height: 160px;
    }
    .gstr-hero-title {
      font-size: 16px;
    }
    .gstr-hero-overlay {
      height: 50px;
      padding-left: 12px;
    }
    .gstr-content-box {
      padding: 14px 10px;
    }
    .gstr-h2 {
      font-size: 18px;
    }
    .gstr-purpose-h2 {
      font-size: 17px;
    }
    .gstr-h3 {
      font-size: 15px;
    }
    .gstr-step-box {
      width: 110px;
      min-height: 80px;
      font-size: 11px;
      padding: 9px 7px;
    }
    .gstr-step-label {
      font-size: 11px;
    }
    .gstr-compare-box {
      font-size: 14px;
    }
  }

  /* ── Very Small: up to 360px ── */
  @media (max-width: 360px) {
    .gstr-hero-img {
      height: 140px;
    }
    .gstr-hero-title {
      font-size: 14px;
    }
    .gstr-hero-overlay {
      height: 46px;
      padding-left: 10px;
    }
    .gstr-h2 {
      font-size: 16px;
    }
    .gstr-purpose-h2 {
      font-size: 15px;
    }
    .gstr-step-box {
      width: 100px;
      min-height: 76px;
      font-size: 10.5px;
      padding: 8px 6px;
    }
    .gstr-step-label {
      font-size: 10px;
      margin-bottom: 4px;
    }
  }
`;

const GSTRReconciliationPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{styles}</style>

      <div
        style={{
          background: "#24c7b8",
          minHeight: "100vh",
          paddingBottom: "50px",
        }}
      >
        {/* HERO SECTION */}
        <div style={{ width: "100%", position: "relative", overflow: "hidden" }}>
          <img src={heroImg} alt="GSTR" className="gstr-hero-img" />

          <div className="gstr-hero-overlay">
            <h1 className="gstr-hero-title">GSTR Reconciliation</h1>
          </div>
        </div>

        {/* MAIN CONTENT */}
        <div className="gstr-content-box">

          {/* PURPOSE */}
          <h2 className="gstr-purpose-h2">Purpose</h2>

          <p style={{ fontSize: "15px", lineHeight: "1.7", marginBottom: "18px" }}>
            Every month, the Organization performs statutory and financial
            reporting activities:
          </p>

          <ul style={{ fontSize: "15px", lineHeight: "1.8", paddingLeft: "30px", marginBottom: "22px" }}>
            <li>Reporting outward supplies in statutory returns (e.g., GSTR)</li>
            <li>Recording corresponding tax liability in the General Ledger (GL)</li>
          </ul>

          <p style={{ fontSize: "15px", lineHeight: "1.7", marginBottom: "18px" }}>
            To ensure accuracy and compliance, both records must match. Any
            mismatch can result in:
          </p>

          <ul style={{ fontSize: "15px", lineHeight: "1.8", paddingLeft: "30px", marginBottom: "40px" }}>
            <li>Incorrect tax liability</li>
            <li>Interest and penalties</li>
            <li>Audit observations</li>
            <li>Compliance risks</li>
          </ul>

          <p style={{ fontSize: "15px", lineHeight: "1.7", fontWeight: "600", marginBottom: "45px" }}>
            This reconciliation acts as a{" "}
            <span style={{ fontWeight: "700" }}>
              key financial and compliance control mechanism
            </span>{" "}
            to prevent such risks.
          </p>

          {/* FLOW BOXES */}
          <div className="gstr-flow-wrap">
            <div className="gstr-step-box">
              <div className="gstr-step-label">Step 1</div>
              <div>Data Collection<br />(GL + Return Data)</div>
            </div>

            <div className="gstr-arrow">→</div>

            <div className="gstr-step-box">
              <div className="gstr-step-label">Step 2</div>
              <div>Data Validation,<br />Standardization &<br />Consolidation</div>
            </div>

            <div className="gstr-arrow">→</div>

            <div className="gstr-step-box">
              <div className="gstr-step-label">Step 3</div>
              <div>Data Pivoting &<br />Comparison</div>
            </div>

            <div className="gstr-arrow">→</div>

            <div className="gstr-step-box">
              <div className="gstr-step-label">Step 4</div>
              <div>Exception Analysis &<br />Root Cause<br />Identification</div>
            </div>

            <div className="gstr-arrow">→</div>

            <div className="gstr-step-box">
              <div className="gstr-step-label">Step 5</div>
              <div>Exception Analysis<br />& Reporting</div>
            </div>
          </div>

          {/* STEP 1 */}
          <h2 className="gstr-h2">Step 1: Data Collection</h2>

          <p style={{ fontSize: "16px", fontWeight: "700", marginBottom: "18px" }}>Objective:</p>

          <ul style={{ fontSize: "15px", lineHeight: "1.8", paddingLeft: "30px" }}>
            <li>Collect/Download required data from:
              <ul style={{ paddingLeft: "25px" }}>
                <li>Financial accounting systems (where transactions are recorded)</li>
                <li>Tax reporting systems or statutory portals (where returns are filed)</li>
              </ul>
            </li>
            <li>Ensure both datasets are available for reconciliation and relate to the same reporting period.</li>
          </ul>

          <h3 className="gstr-h3">Types of Systems Involved for Data Collection:</h3>

          <ol style={{ fontSize: "15px", lineHeight: "1.9", paddingLeft: "30px" }}>
            <li>
              <strong>Primary Financial System</strong><br />
              (Where transactions are recorded in books of accounts)
            </li>
            <li style={{ marginTop: "16px" }}>
              <strong>Reporting / Regulatory System</strong><br />
              (Where statutory, compliance, or operational reporting is performed)
            </li>
          </ol>

          <h3 className="gstr-h3">Possible Data Sources (Organization Dependent):</h3>

          <ul style={{ fontSize: "15px", lineHeight: "1.9", paddingLeft: "30px" }}>
            <li>ERP systems (Oracle, SAP, Microsoft Dynamics, etc.)</li>
            <li>Accounting software</li>
            <li>Internal reporting tools</li>
            <li>GST / Tax authority portals</li>
            <li>Web-based platforms</li>
            <li>Shared drives or folders</li>
          </ul>

          <img src={step1Img} alt="" className="gstr-step-img" />

          {/* STEP 2 */}
          <h2 className="gstr-h2">Step 2: Data Validation, Standardization & Consolidation</h2>

          <p style={{ fontSize: "16px", fontWeight: "700", marginBottom: "18px" }}>Objective</p>

          <ul style={{ fontSize: "15px", lineHeight: "1.8", paddingLeft: "30px" }}>
            <li>Ensure data is accurate, complete, and consistent before comparison.</li>
            <li>Remove incomplete, duplicate, or irrelevant records.</li>
            <li>Consolidate data from multiple sources into a unified dataset.</li>
            <li>Merging multiple entity reports at PAN or group level.</li>
            <li>Standardize formats (Finalize document numbers, date formats, Summation of tax values, reference IDs).</li>
          </ul>

          <h3 className="gstr-h3">Activities May Include</h3>

          <ul style={{ fontSize: "15px", lineHeight: "1.9", paddingLeft: "30px" }}>
            <li>Cleaning incorrect or incomplete entries</li>
            <li>Consolidate multiple GL accounts data into single structured dataset.</li>
          </ul>

          <p style={{ fontSize: "15px", marginLeft: "20px", marginTop: "-15px", marginBottom: "10px", lineHeight: "1.5" }}>
            (Multiple GL accounts, B2B, B2C, Exports, advances)
          </p>

          <ul style={{ fontSize: "15px", lineHeight: "1.9", paddingLeft: "30px", marginTop: "10px" }}>
            <li>Categorize data into specific groups (Freight, Non-Freight, Revenue)</li>
            <li>Converting values where required (e.g., credit entries as negative)</li>
            <li>Segregating exceptions such as:</li>
          </ul>

          <ul style={{ fontSize: "15px", lineHeight: "1.9", paddingLeft: "70px" }}>
            <li>Same month cancellations</li>
            <li>Ineligible transactions</li>
            <li>Prior Period items</li>
            <li>Replacement cases</li>
            <li>Zero Tax transactions</li>
          </ul>

          <img src={step2Img} alt="" className="gstr-step-img" style={{ marginBottom: "70px" }} />

          {/* STEP 3 */}
          <h2 className="gstr-h2">Step 3: Data Pivoting & Comparison</h2>

          <p style={{ fontSize: "16px", fontWeight: "700", marginBottom: "18px" }}>Objective</p>

          <ul style={{ fontSize: "15px", lineHeight: "1.8", paddingLeft: "30px" }}>
            <li>Group transactions by Final document Number/Internal reference Number/ Invoice number.</li>
            <li>Summarize tax components or financial values at the required level.</li>
            <li>Calculate differences between datasets.</li>
            <li>Provide clear remarks based on comparison results, including predefined tolerance limits.</li>
          </ul>

          <h3 className="gstr-h3">Examples of Aggregated Comparisons (Illustrative)</h3>

          <p style={{ fontSize: "15px", lineHeight: "1.7" }}>
            Depending on business requirement, reconciliation may include:
          </p>

          <ul style={{ fontSize: "15px", lineHeight: "1.8", paddingLeft: "30px", marginTop: "15px" }}>
            <li>GSTR-1 vs GL – Tax Liability</li>
            <li>GSTR-2 / ITC vs GL – Input Tax</li>
            <li>GSTR-1 vs GL Revenue vs GL Freight vs Non-Freight</li>
            <li>AIS vs 2B, AIS vs 3B</li>
          </ul>

          <h3 className="gstr-h3">Comparison Logic</h3>

          <p style={{ fontSize: "15px", lineHeight: "1.7" }}>For each grouped document or category:</p>

          <div className="gstr-compare-box">Difference = Source A – Source B</div>

          <p style={{ fontSize: "15px", lineHeight: "1.7" }}>
            Based on the result, provide remarks to facilitate efficient review and decision-making
          </p>

          <div style={{ marginTop: "28px", marginBottom: "45px" }}>
            <div style={{ fontSize: "16px", marginBottom: "14px", fontWeight: "600" }}>
              Difference = 0 — Matched
            </div>
            <div style={{ fontSize: "16px", marginBottom: "14px", fontWeight: "600" }}>
              Within Tolerance — Minor difference
            </div>
            <div style={{ fontSize: "16px", fontWeight: "600" }}>
              Exceeds Tolerance — Not Matched/Manual Review required
            </div>
          </div>

          <img src={step3Img} alt="" className="gstr-step-img" />

          {/* STEP 4 */}
          <h2 className="gstr-h2">Step 4: Exception Analysis & Root Cause Identification</h2>

          <p style={{ fontSize: "16px", fontWeight: "700", marginBottom: "18px" }}>Objective</p>

          <ul style={{ fontSize: "15px", lineHeight: "1.8", paddingLeft: "30px" }}>
            <li>Analyze all "Not Matched" cases.</li>
            <li>Identify the reason for variance using business rules provided.</li>
            <li>Update remarks with meaningful, business-friendly explanations.</li>
            <li>Enable corrective action by relevant stakeholders.</li>
          </ul>

          <h3 className="gstr-h3-sm">Common Categories of Exception can be as below:</h3>

          <img src={step4Img} alt="" className="gstr-step-img" />

          {/* STEP 5 */}
          <h2 className="gstr-h2">Step 5: Reporting Summary & Execution Status</h2>

          <ul style={{ fontSize: "15px", lineHeight: "1.8", paddingLeft: "30px" }}>
            <li>Share reconciliation summary report with relevant end users.</li>
            <li>Posting Matched Data to ERP Systems.</li>
            <li>Email Distribution & Archive.</li>
            <li><strong>Report Distribution Methods</strong></li>
          </ul>

          <ul style={{ fontSize: "15px", lineHeight: "1.9", paddingLeft: "70px" }}>
            <li>Automated email to stakeholders</li>
            <li>Shared drive/folder</li>
          </ul>

          <img src={step5Img} alt="" className="gstr-step-img" />

          {/* NEXT PAGE */}
          <div className="gstr-next-box">
            <h2 className="gstr-next-title">
              Automating Purchase & Sales Invoice Entry into SAP: A Research
              Guide to Document AI, APIs, and LLMs
            </h2>
            <button
              onClick={() => navigate("/blogs/sap-automation")}
              style={{
                background: "transparent",
                border: "none",
                color: "#d4d4d4",
                fontSize: "17px",
                cursor: "pointer",
                fontWeight: "500",
              }}
            >
              ← Previous post
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default GSTRReconciliationPage;
